import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export function RescheduleEmptyState() {
  return (
    <div
      data-testid={DataTestIdEnum.APPOINTMENT_RESCHEDULE_EMPTY}
      className="flex flex-col items-center justify-center px-6 py-10 text-center"
    >
      <Typography variant={TypographyVariant.BODY_TEXT} className="text-gray-700">
        Sem horários disponíveis no momento.
      </Typography>
    </div>
  );
}
